// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "customer-260429-0/static/css/" + chunkId + "." + {"164":"93104331","710":"93104331","2280":"0145b7c0","2395":"93104331","2473":"0145b7c0","2918":"0145b7c0","2982":"07a465cd","6264":"93104331","7347":"0145b7c0"}[chunkId] + ".chunk.css";
};